import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./Newsletter.css";

const Newsletter = () => {
  const { pathname } = useLocation();
  const isExpanded = pathname === "/membership" || pathname === "/support";

  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [status, setStatus] = useState("");

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsValid(validateEmail(value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid) return;

    setStatus("loading");

    try {
      const res = await fetch(
        "https://beszeljegyesulet.hu/wp/wp-json/beszelj/v1/newsletter",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();

      if (res.ok) {
        setStatus("success");
        setEmail("");
        setIsValid(false);
      } else {
        setStatus(data?.message || "error");
      }
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <section className={`newsletter ${isExpanded ? "newsletter-expanded" : ""}`}>
      <div className="newsletter-inner">
        {/* LEFT COLUMN — Only visible on Membership + Support */}
        {isExpanded && (
          <div className="newsletter-left">
            <h2 className="heading-md">Csak a hírlevel érdekelne?</h2>
            <p className="body-sm">
              Iratkozz fel hírlevelünkre, ha szeretnél időnként értesülni programjainkról, eseményeinkről és a dadogással kapcsolatos hasznos tartalmakról.
            </p>
            {/* <p className="body-sm">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p> */}
          </div>
        )}

        {/* RIGHT COLUMN */}
        <div className="newsletter-right">
          <h2 className="heading-md newsletter-title">
            Iratkozz fel hírlevelünkre, és értesülj a legfrissebb hírekről és
            frissítésekről!
          </h2>

          <form className="newsletter-form body-md" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Írd be az email címed itt"
              value={email}
              onChange={handleChange}
              required
            />

            <button
              type="submit"
              className={`newsletter-button ${isValid ? "active" : ""}`}
              disabled={!isValid || status === "loading"}
            >
              <b>
                {status === "loading"
                  ? "Feldolgozás..."
                  : "Iratkozz fel a hírlevelünkre"}
              </b>
            </button>
          </form>

          {status === "success" && (
            <p className="newsletter-success">Köszönjük a feliratkozást!</p>
          )}
          {status === "error" && (
            <p className="newsletter-error">
              Hiba történt. Kérjük próbáld meg később.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
